import cx from 'classnames';
import { Heading, Paragraph } from 'components/Typography';

export type Props = {
  title?: string;
  subTitle?: string;
  children?: React.ReactNode;
  className?: string;
  id?: string;
};

export const AccordionList = ({ title, subTitle, children, className, id }: Props): JSX.Element => {
  return (
    <div id={id} className={cx('rounded-md bg-white divide-y divide-black/16 w-full', className)}>
      {title && (
        <div className="flex flex-col gap-16 p-40 sm-d:p-32">
          <Heading level="h3">{title}</Heading>
          {subTitle && <Paragraph>{subTitle}</Paragraph>}
        </div>
      )}
      {children}
    </div>
  );
};
